import ServicesMenuPage from './ServicesMenuPage';
export type { ServicesMenuPageProps } from './ServicesMenuPage.types';

export default ServicesMenuPage;
